import { render } from "./MacmaporgCustomsDutyCard.vue?vue&type=template&id=0f245680"
import script from "./MacmaporgCustomsDutyCard.vue?vue&type=script&lang=js"
export * from "./MacmaporgCustomsDutyCard.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__